import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoTable, DiscoText } from "@disco-ui"
import { TableCell } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"

interface Props {
  fieldName: string
  response: React.ReactNode | string
}

function AdminMembersReportStandardProfileFieldsTableRow({ fieldName, response }: Props) {
  const classes = useStyles()
  return (
    <DiscoTable.Row>
      {/* Field name */}
      <TableCell className={classes.tableCell}>
        <DiscoText>{fieldName}</DiscoText>
      </TableCell>

      {/* Response */}
      <TableCell className={classes.tableCell}>
        <DiscoText>
          {typeof response === "string" ? (
            <DiscoText>{response || "-"}</DiscoText>
          ) : (
            response
          )}
        </DiscoText>
      </TableCell>
    </DiscoTable.Row>
  )
}

const useStyles = makeUseStyles({
  tableCell: {
    verticalAlign: "top",
  },
})

export function AdminMembersReportStandardProfileFieldsTableRowSkeleton() {
  return (
    <DiscoTable.Row>
      <TableCell width={"25%"}>
        <Skeleton variant={"rect"} />
      </TableCell>
      <TableCell width={"75%"}>
        <Skeleton variant={"rect"} />
      </TableCell>
    </DiscoTable.Row>
  )
}

export default AdminMembersReportStandardProfileFieldsTableRow
